<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col>
        <b-row>
          <b-col>
            <div class="form-group">
              <label
                      for="exsbdocument_documentType"
                      class="form-control-label">{{$t('views.exsbdocument.form.documentType')}}:</label>
              <fg-input :error="violations.documentType">
                <el-select
                        id="exsbdocument_documentType"
                        :class="['select-default', isInvalid('periodType') ? 'select-danger' : '']"
                        :placeholder="$t('views.exsbdocument.form.documentType')"
                        :disabled="item.positions.length > 0 || ordersDocument"
                        filterable
                        v-model="item.documentType">
                  <el-option v-for="option in documentTypes"
                             class="select-default"
                             :value="option['@id']"
                             :label="option.name"
                             :key="option['@id']">
                  </el-option>
                </el-select>
              </fg-input>
              <div
                      v-if="isInvalid('documentType')"
                      class="invalid-feedback">{{ violations.documentType }}</div>
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label
                      for="exsbdocument_batchNumber"
                      class="form-control-label">{{$t('views.exsbdocument.form.batchNumber')}}:</label>
              <model-select :isDisabled="item['@id'] || item.documentType === undefined" v-model="item.batchNumber" :options="batchNumbersOptions" name="batchNumber" id="batchNumber" :placeholder="$t('views.exsbinvoices.form.batchNumber')">
              </model-select>
            </div>
          </b-col>
          <b-col v-if="item['@id']">
            <div class="form-group">
              <label
                      for="exsbdocument_number"
                      class="form-control-label">{{$t('views.exsbdocument.form.number')}}:</label>
              <input
                      id="exsbdocument_number"
                      v-model="item.number"
                      :class="['form-control', isInvalid('number') ? 'is-invalid' : '']"
                      type="text"
                      disabled="true"
                      placeholder=""
                      @input="handleUpdateField('number', $event.target.value)">
              <div
                      v-if="isInvalid('number')"
                      class="invalid-feedback">{{ violations.number }}</div>
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label
                      for="exsbdocument_dateOfIssue"
                      class="form-control-label">{{$t('views.exsbdocument.form.dateOfIssue')}}:</label>
              <fg-input :error="violations.dateOfIssue">
                <el-date-picker
                        :picker-options="{firstDayOfWeek: 1}"
                        v-model="item.dateOfIssue"
                        type="date"
                        :placeholder="$t('views.exsbdocument.form.dateOfIssue')"
                        default-time="12:00:00">
                </el-date-picker>
              </fg-input>
              <div
                      v-if="isInvalid('dateOfIssue')"
                      class="invalid-feedback">{{ violations.dateOfIssue }}</div>
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label
                for="exsbdocument_placeOfIssue"
                class="form-control-label">{{$t('views.exsbdocument.form.placeOfIssue')}}:</label>
              <input
                id="exsbdocument_placeOfIssue"
                v-model="item.placeOfIssue"
                :class="['form-control', isInvalid('placeOfIssue') ? 'is-invalid' : '']"
                type="text"
                placeholder=""
                @input="handleUpdateField('placeOfIssue', $event.target.value)">
              <div
                v-if="isInvalid('placeOfIssue')"
                class="invalid-feedback">{{ violations.placeOfIssue }}</div>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="getIdLink(item.documentType) == 1">
          <b-col>
            <div class="form-group">
              <label
                      for="exsbdocument_delivery"
                      class="form-control-label">{{$t('views.exsbdocument.form.delivery')}}:</label>
              <fg-input :error="violations.delivery">
                <el-select
                        id="exsbdocument_delivery"
                        :class="['select-default', isInvalid('delivery') ? 'select-danger' : '']"
                        :placeholder="$t('views.exsbdocument.form.delivery')"
                        filterable
                        v-model="item.delivery">
                  <el-option v-for="option in deliveries"
                             class="select-default"
                             :value="option['@id']"
                             :label="option.name"
                             :key="option['@id']">
                  </el-option>
                </el-select>
              </fg-input>
              <div
                      v-if="isInvalid('delivery')"
                      class="invalid-feedback">{{ violations.delivery }}</div>
            </div>
          </b-col>
        </b-row>
        <div>
          <div class="d-sm-block d-md-inline-block mr-2">
            <h6 class="mt-3 mb-1">{{ $t('views.exsbdocument.form.exhibitorData') }}:</h6>
          </div>
          <div class="d-sm-block d-md-inline-block contractor-input" v-if="currentDocumentTypeId === 2">
            <model-select v-model="selectedContractor" :options="contractorOptions"></model-select>
          </div>
        </div>
        <b-row>
          <b-col>
            <div class="form-group">
              <label
                for="exsbdocument_exhibitorNip"
                class="form-control-label">{{$t('views.exsbdocument.form.exhibitorNip')}}:</label>
              <input
                id="exsbdocument_exhibitorNip"
                v-model="item.exhibitorNip"
                :class="['form-control', isInvalid('exhibitorNip') ? 'is-invalid' : '']"
                type="text"
                :disabled="ordersDocument"
                placeholder=""
                @input="handleUpdateField('exhibitorNip', $event.target.value)">
              <div
                v-if="isInvalid('exhibitorNip')"
                class="invalid-feedback">{{ violations.exhibitorNip }}</div>
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label
                for="exsbdocument_exhibitor"
                class="form-control-label">{{$t('views.exsbdocument.form.exhibitor')}}:</label>
              <input
                id="exsbdocument_exhibitor"
                v-model="item.exhibitor"
                :class="['form-control', isInvalid('exhibitor') ? 'is-invalid' : '']"
                type="text"
                :disabled="ordersDocument"
                placeholder=""
                @input="handleUpdateField('exhibitor', $event.target.value)">
              <div
                v-if="isInvalid('exhibitor')"
                class="invalid-feedback">{{ violations.exhibitor }}</div>
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label
                for="exsbdocument_exhibitorStreet"
                class="form-control-label">{{$t('views.exsbdocument.form.exhibitorStreet')}}:</label>
              <input
                id="exsbdocument_exhibitorStreet"
                v-model="item.exhibitorStreet"
                :class="['form-control', isInvalid('exhibitorStreet') ? 'is-invalid' : '']"
                type="text"
                :disabled="ordersDocument"
                placeholder=""
                @input="handleUpdateField('exhibitorStreet', $event.target.value)">
              <div
                v-if="isInvalid('exhibitorStreet')"
                class="invalid-feedback">{{ violations.exhibitorStreet }}</div>
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label
                for="exsbdocument_exhibitorCity"
                class="form-control-label">{{$t('views.exsbdocument.form.exhibitorCity')}}:</label>
              <input
                id="exsbdocument_exhibitorCity"
                v-model="item.exhibitorCity"
                :class="['form-control', isInvalid('exhibitorCity') ? 'is-invalid' : '']"
                type="text"
                :disabled="ordersDocument"
                placeholder=""
                @input="handleUpdateField('exhibitorCity', $event.target.value)">
              <div
                v-if="isInvalid('exhibitorCity')"
                class="invalid-feedback">{{ violations.exhibitorCity }}</div>
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label
                for="exsbdocument_exhibitorPostcode"
                class="form-control-label">{{$t('views.exsbdocument.form.exhibitorPostcode')}}:</label>
              <input
                id="exsbdocument_exhibitorPostcode"
                v-model="item.exhibitorPostcode"
                :class="['form-control', isInvalid('exhibitorPostcode') ? 'is-invalid' : '']"
                type="text"
                :disabled="ordersDocument"
                placeholder=""
                @input="handleUpdateField('exhibitorPostcode', $event.target.value)">
              <div
                v-if="isInvalid('exhibitorPostcode')"
                class="invalid-feedback">{{ violations.exhibitorPostcode }}</div>
            </div>
          </b-col>
        </b-row>
        <template v-if="getIdLink(item.documentType) == 1 || getIdLink(item.documentType) == 2 || getIdLink(item.documentType) == 3">
          <div>
            <div class="d-sm-block d-md-inline-block mr-2">
              <h6 class="mt-3 mb-1">{{ $t('views.exsbdocument.form.receiverData') }}:</h6>
            </div>
            <div class="d-sm-block d-md-inline-block contractor-input" v-if="currentDocumentTypeId === 1">
              <model-select v-model="selectedContractor" :options="contractorOptions"></model-select>
            </div>
          </div>
          <b-row>
            <b-col>
              <div class="form-group">
                <label
                        for="exsbdocument_receiverNip"
                        class="form-control-label">{{$t('views.exsbdocument.form.receiverNip')}}:</label>
                <input
                        id="exsbdocument_receiverNip"
                        v-model="item.receiverNip"
                        :class="['form-control', isInvalid('receiverNip') ? 'is-invalid' : '']"
                        type="text"
                        :disabled="ordersDocument"
                        placeholder=""
                        @input="handleUpdateField('receiverNip', $event.target.value)">
                <div
                        v-if="isInvalid('receiverNip')"
                        class="invalid-feedback">{{ violations.receiverNip }}</div>
              </div>
            </b-col>
            <b-col>
              <div class="form-group">
                <label
                  for="exsbdocument_receiver"
                  class="form-control-label">{{$t('views.exsbdocument.form.receiver')}}:</label>
                <input
                  id="exsbdocument_receiver"
                  v-model="item.receiver"
                  :class="['form-control', isInvalid('receiver') ? 'is-invalid' : '']"
                  type="text"
                  :disabled="ordersDocument"
                  placeholder=""
                  @input="handleUpdateField('receiver', $event.target.value)">
                <div
                  v-if="isInvalid('receiver')"
                  class="invalid-feedback">{{ violations.receiver }}</div>
              </div>
            </b-col>
            <b-col>
              <div class="form-group">
                <label
                        for="exsbdocument_receiverStreet"
                        class="form-control-label">{{$t('views.exsbdocument.form.receiverStreet')}}:</label>
                <input
                        id="exsbdocument_receiverStreet"
                        v-model="item.receiverStreet"
                        :class="['form-control', isInvalid('receiverStreet') ? 'is-invalid' : '']"
                        type="text"
                        :disabled="ordersDocument"
                        placeholder=""
                        @input="handleUpdateField('receiverStreet', $event.target.value)">
                <div
                        v-if="isInvalid('receiverStreet')"
                        class="invalid-feedback">{{ violations.receiverStreet }}</div>
              </div>
            </b-col>
            <b-col>
              <div class="form-group">
                <label
                        for="exsbdocument_receiverCity"
                        class="form-control-label">{{$t('views.exsbdocument.form.receiverCity')}}:</label>
                <input
                        id="exsbdocument_receiverCity"
                        v-model="item.receiverCity"
                        :class="['form-control', isInvalid('receiverCity') ? 'is-invalid' : '']"
                        type="text"
                        :disabled="ordersDocument"
                        placeholder=""
                        @input="handleUpdateField('receiverCity', $event.target.value)">
                <div
                        v-if="isInvalid('receiverCity')"
                        class="invalid-feedback">{{ violations.receiverCity }}</div>
              </div>
            </b-col>
            <b-col>
              <div class="form-group">
                <label
                        for="exsbdocument_receiverPostcode"
                        class="form-control-label">{{$t('views.exsbdocument.form.receiverPostcode')}}:</label>
                <input
                        id="exsbdocument_receiverPostcode"
                        v-model="item.receiverPostcode"
                        :class="['form-control', isInvalid('receiverPostcode') ? 'is-invalid' : '']"
                        type="text"
                        :disabled="ordersDocument"
                        placeholder=""
                        @input="handleUpdateField('receiverPostcode', $event.target.value)">
                <div
                        v-if="isInvalid('receiverPostcode')"
                        class="invalid-feedback">{{ violations.receiverPostcode }}</div>
              </div>
            </b-col>
          </b-row>
        </template>
        <b-row v-if="getIdLink(item.documentType) == 5">
          <b-col>
            <div class="form-group">
              <label
                      for="exsbdocument_protocolPeriodStart"
                      class="form-control-label">{{$t('views.exsbdocument.form.protocolPeriodStart')}}:</label>
              <fg-input :error="violations.protocolPeriodStart">
                <el-date-picker
                        :picker-options="{firstDayOfWeek: 1}"
                        v-model="item.protocolPeriodStart"
                        type="date"
                        :placeholder="$t('views.exsbdocument.form.protocolPeriodStart')"
                        default-time="12:00:00">
                </el-date-picker>
              </fg-input>
              <div
                      v-if="isInvalid('protocolPeriodStart')"
                      class="invalid-feedback">{{ violations.protocolPeriodStart }}</div>
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label
                      for="exsbdocument_protocolPeriodEnd"
                      class="form-control-label">{{$t('views.exsbdocument.form.protocolPeriodEnd')}}:</label>
              <fg-input :error="violations.protocolPeriodEnd">
                <el-date-picker
                        :picker-options="{firstDayOfWeek: 1}"
                        v-model="item.protocolPeriodEnd"
                        type="date"
                        :placeholder="$t('views.exsbdocument.form.protocolPeriodEnd')"
                        default-time="12:00:00">
                </el-date-picker>
              </fg-input>
              <div
                      v-if="isInvalid('protocolPeriodEnd')"
                      class="invalid-feedback">{{ violations.protocolPeriodEnd }}</div>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="item">
          <b-col>
            <b-row v-if="item.positions.length > 0">
              <b-col>
                <hr>
              </b-col>
            </b-row>
            <Position v-for="(documentPosition, index) in item.positions"
                      :errors="errors"
                      :ordersDocument="ordersDocument"
                      :violations="violations"
                      :handleUpdateField="handleUpdateField"
                      :documentPosition="documentPosition"
                      :itemsArray="itemsArray"
                      :warehouses="warehouses"
                      :reasons="reasons"
                      :vatRates="vatRates"
                      :index="index"
                      :documentPositions="item.positions"
                      :documentType="parseInt(getIdLink(item.documentType))"
                      v-bind:key="index"></Position>
            <b-row v-if="!ordersDocument">
              <b-col>
                <b-button v-if="item.documentType" class="btn btn-primary" @click="addNewPosition()">{{ $t('views.exsbdocument.form.addNewPosition') }}</b-button>
                <b-button v-else class="btn btn-disabled"
                          v-b-tooltip.hover :title="$t('views.exsbdocument.form.addNewPositionTooltip')"
                >{{ $t('views.exsbdocument.form.addNewPosition') }}</b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="form-group">
              <label
                      for="exsbdocument_comments"
                      class="form-control-label">{{$t('views.exsbdocument.form.comments')}}:</label>
              <input
                      id="exsbdocument_comments"
                      v-model="item.comments"
                      :class="['form-control', isInvalid('comments') ? 'is-invalid' : '']"
                      type="text"
                      placeholder=""
                      @input="handleUpdateField('comments', $event.target.value)">
              <div
                      v-if="isInvalid('comments')"
                      class="invalid-feedback">{{ violations.comments }}</div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <button
      type="submit"
      class="btn btn-primary">{{ $t('buttons.submit') }}</button>
    <b-btn v-if="$route.name !== 'EXSBDocumentCreate'" @click="closeModal()">{{ $t('buttons.close') }}</b-btn>
  </form>
</template>

<script>
import getId from '@/utils/getIdFromLink'
import Position from './components/Position'
import { mapActions, mapGetters } from 'vuex'
import addParamsToQuery from '@/utils/addParamsToQuery'
import { getUserRoles } from '@/utils/checkRoles'
import { ModelSelect } from 'vue-search-select'

export default {
  components: {
    Position,
    ModelSelect
  },

  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    },

    ordersDocument: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      reasons: 'exsbreason/list/items',
      vatRates: 'exsbvatrate/list/items',
      warehouses: 'exsbwarehouse/list/items',
      itemsArray: 'exsbitem/list/items',
      documentTypes: 'exsbdocumenttype/list/items',
      batchNumbers: 'exsbinvoice/list/batchNumberOptions',
      deliveries: 'exsbdelivery/list/items',
      firms: 'exsbinvoice/list/firmOptions'
    }),
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    },

    currentDocumentTypeId () {
      if (this.item.documentType) return parseInt(getId(this.item.documentType))
      else return null
    },

    contractorOptions () {
      return this.firms.map(entry => {
        return {
          value: entry['@id'],
          text: entry.firmname1 === '' ? entry.fullName : entry.firmname1
        }
      })
    },
    batchNumbersOptions () {
      let array = []
      array.push({ value: null, text: this.$t('views.exsbinvoices.form.noBatchNumber') })
      if (this.batchNumbers && this.batchNumbers.length > 0) {
        this.batchNumbers.forEach((entry) => {
          if (entry.documentsAllowed.includes(this.item.documentType)) {
            array.push({ value: entry.value, text: entry.text })
          }
        })
      }
      return array
    }
  },
  watch: {
    firms (val) {
      if (val && val.length > 0) {
        this.fillExhibitorData(this.getUserEmployee())
        this.clearReceiverData()
      }
    },
    'item.documentType' (val) {
      if (val) {
        if (this.getIdLink(this.item.documentType) === '2') { // Dla przyjęcia zewnętrznego odbiorcą jesteśmy my - firma gdzie jest zatrudniony zalogowany użytkownik
          this.fillReceiverData(this.getUserEmployee())
          this.clearExhibitorData()
        } else {
          this.fillExhibitorData(this.getUserEmployee())
          this.clearReceiverData()
        }
      }
      this.fetchBatchNumberOptions()
      this.selectedContractor = ''
    },
    selectedContractor (val) {
      let selectedFirmData = this.firms.find(entry => entry['@id'] === val)
      if (this.currentDocumentTypeId === 2) {
        this.fillExhibitorData(selectedFirmData)
      } else if (this.currentDocumentTypeId === 1) {
        this.fillReceiverData(selectedFirmData)
      }
    }
  },
  data () {
    return {
      selectedContractor: ''
    }
  },

  created () {
    this.getDocumentTypes()
    this.getDeliveriesTypes()
    this.fetchBatchNumberOptions()
    this.getItems()
    this.getWarehouses()
    this.getVatRates()
    this.getReasons()
    this.fetchFirmOptions()
  },

  methods: {
    ...mapActions({
      fetchVatRates: 'exsbvatrate/list/default',
      fetchWarehouses: 'exsbwarehouse/list/default',
      fetchItems: 'exsbitem/list/getItems',
      fetchDocumentTypes: 'exsbdocumenttype/list/default',
      fetchBatchNumberOptions: 'exsbinvoice/list/fetchBatchNumberOptions',
      fetchDeliveries: 'exsbdelivery/list/default',
      fetchReasons: 'exsbreason/list/default',
      fetchFirmOptions: 'exsbinvoice/list/fetchFirmOptions'
    }),
    getUserEmployee () {
      // zwraca firmę w której zatruniony jest zalogowany użytkownik
      return this.firms.filter(entry => {
        return entry.userDataEmployees.some(element => {
          return getId(element.employee['@id']) === getUserRoles().id_userdata
        })
      })[0]
    },
    clearReceiverData () {
      this.item.receiverNip = ''
      this.item.receiver = ''
      this.item.receiverStreet = ''
      this.item.receiverCity = ''
      this.item.receiverPostcode = ''
    },
    fillExhibitorData (exhibitor) {
      if (exhibitor) {
        this.item.exhibitorNip = exhibitor.nip
        this.item.exhibitor = exhibitor.firmname1
        this.item.exhibitorStreet = exhibitor.street
        this.item.exhibitorCity = exhibitor.city
        this.item.exhibitorPostcode = exhibitor.postcode
      }
    },
    clearExhibitorData () {
      this.item.exhibitorNip = ''
      this.item.exhibitor = ''
      this.item.exhibitorStreet = ''
      this.item.exhibitorCity = ''
      this.item.exhibitorPostcode = ''
    },
    fillReceiverData (receiver) {
      if (receiver) {
        this.item.receiverNip = receiver.nip
        this.item.receiver = receiver.firmname1
        this.item.receiverStreet = receiver.street
        this.item.receiverCity = receiver.city
        this.item.receiverPostcode = receiver.postcode
      }
    },
    closeModal () {
      this.$store.state.modals.exsborder.generateDocument.close = 1
    },
    addNewPosition () {
      let object = {
        pricePerUnitBrutto: '0.00',
        pricePerUnitNetto: '0.00',
        quantity: 1,
        discount: '0.00',
        valueNetto: '0.00',
        valueBrutto: '0.00',
        vatRate: '',
        warehouseQuantity: 0,
        newWarehouseQuantity: 0
      }
      this.item.positions.push(object)
    },
    getReasons () {
      let params = {
        'pagination': false
      }
      this.fetchReasons(addParamsToQuery('e_x_s_b_reasons', params))
    },
    getVatRates () {
      let params = {
        'pagination': false
      }
      this.fetchVatRates(addParamsToQuery('e_x_s_b_vat_rates', params))
    },
    getWarehouses () {
      let params = {
        'pagination': false,
        'forUserData': 0
      }
      this.fetchWarehouses(addParamsToQuery('e_x_s_b_warehouses', params))
    },
    getItems () {
      let params = {
        'pagination': false
      }
      this.fetchItems(addParamsToQuery('e_x_s_b_items', params))
    },
    getDocumentTypes () {
      let params = {
        'pagination': false
      }
      this.fetchDocumentTypes(addParamsToQuery('e_x_s_b_document_types', params))
    },
    getDeliveriesTypes () {
      let params = {
        'pagination': false
      }
      this.fetchDeliveries(addParamsToQuery('e_x_s_b_deliveries', params))
    },

    clearDataByDocumentType (val) {
      if (val !== 1) {
        this.item.delivery = null
      }
      if (val !== 1 && val !== 2 && val !== 3) {
        this.item.receiverNip = ''
        this.item.receiverStreet = ''
        this.item.receiverCity = ''
        this.item.receiverPostcode = ''
      }
      if (val !== 5) {
        this.item.protocolPeriodStart = ''
        this.item.protocolPeriodEnd = ''
      }
      this.item.positions = []
    },

    getIdLink (link) {
      return getId(link)
    },

    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
<style scoped>
.contractor-input {
  width: 20%
}

@media only screen and (max-width: 768px) {
  .contractor-input {
    width: 100%
  }
}
</style>
